<div class="{{isVerticalBar ? 'c__vertical-bar' : 'c__horizontal-bar'}}"></div>
